import type { ComponentPropsWithoutRef } from 'react'

const DefaultButton = ({ className = '', ...props }: ComponentPropsWithoutRef<'button'>) => (
  <button className={`group ext-button text-sm ${className}`} {...props} />
)

export default DefaultButton
